import React, { FC, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IState } from "store/store.interface";
import { isEmpty } from "utils/app.utils";
import LoaderCampaings from "Loader/Dashboard";
import { useApiInfo } from "hooks";
import { BUNDLE_PROMOTION_FETCH_CAMPAIGNS } from "store/store.types";
import { fetchBundleCampaigns, clearBundleCampaingsList } from "store/actions/bundlePromotion.actions";
import { Box } from "common";
import BundlePromotionItem from "./BundlePromotionItem";
import {useStyles} from '../../Dashboard/Dashboard.style'
import EmptyState from "components/Dashboard/EmptyState";

const BundlePromotionListing: FC<{ listing?: "list" | "grid" }> = ({ listing }) => {
  const { bundleDashboard, newBundleCampaign, searchTerm } = useSelector(
    (state: IState) => ({...state.bundlePromotion, ...state.promotion})
  );

  const { container, emptyContainer } = useStyles({ listing });

  const dispatch = useDispatch();
  const { isLoading } = useApiInfo(BUNDLE_PROMOTION_FETCH_CAMPAIGNS);

  const latestSearchTerm = useRef(searchTerm);

  // This is used when new campaign is created to update the list
  useEffect(() => {
    if (newBundleCampaign) {
      dispatch(fetchBundleCampaigns());
    }
  }, [newBundleCampaign, dispatch]);

  // This is used to fetch when dashboard is empty
  useEffect(() => {
    if (!bundleDashboard || bundleDashboard?.length === 0) {
      dispatch(fetchBundleCampaigns());
    }
  }, [dispatch]);

  // This is used to keep the latest search term
  useEffect(() => {
    latestSearchTerm.current = searchTerm;
  }, [searchTerm]);

  // This is used to clear list when unmounting if a search was active
  useEffect(() => {
    return () => {
      if (latestSearchTerm.current) {
        dispatch(clearBundleCampaingsList());
      }
    };
  }, [dispatch]);

  if (isEmpty(bundleDashboard) && isLoading) {
    return <LoaderCampaings />;
  }

  return (
    <Box className={(bundleDashboard && bundleDashboard.length > 0) ? container : emptyContainer} width="100%" gridGap="25px">
      {bundleDashboard && bundleDashboard.length > 0 ? (
        <>
          {bundleDashboard.filter((promotion)=>["BUNDLE_CAMPAIGN", "FREE_GIFT"]?.includes(promotion.type!)).map((promotion, index) => {
            const { campaignId } = promotion;
            return (
              <BundlePromotionItem
                promotion={promotion}
                key={`${campaignId}_${index}`}
                listing={listing}
              />
            );
          })}
        </>
      ) : (
        <EmptyState isBundlePromotion={true} />
      )}
    </Box>
  );
};

export default BundlePromotionListing;
